export enum ELayout {
  "dashboard",
  "table",
  // "map",
}
